export const HONG_KONG_COUNTRY_CODE = '+852';
export const HONG_KONG_COUNTRY_CODE_OPTIONS = [
  { value: HONG_KONG_COUNTRY_CODE, text: HONG_KONG_COUNTRY_CODE },
];

export const buildSignUpRegistrationPayload = (data: SMSRegisterRequired): SMSRegisterRequired => ({
  ...data,
  email: data.email.trim(),
  phone_country_code: data.otp_method === 'sms' ? HONG_KONG_COUNTRY_CODE.slice(1) : '',
  phone_number: data.otp_method === 'sms' ? data.phone_number.trim() : '',
});
